/* eslint-disable */
// source: triallimits.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.core.private.triallimits.CreateAlternateTrialLimitRequest', null, global);
goog.exportSymbol('proto.core.private.triallimits.CreateAlternateTrialLimitResponse', null, global);
goog.exportSymbol('proto.core.private.triallimits.DeleteAlternateTrialLimitRequest', null, global);
goog.exportSymbol('proto.core.private.triallimits.DeleteAlternateTrialLimitResponse', null, global);
goog.exportSymbol('proto.core.private.triallimits.GetTrialLimitsRequest', null, global);
goog.exportSymbol('proto.core.private.triallimits.GetTrialLimitsResponse', null, global);
goog.exportSymbol('proto.core.private.triallimits.TrialLimit', null, global);
goog.exportSymbol('proto.core.private.triallimits.UpdateAlternateTrialLimitRequest', null, global);
goog.exportSymbol('proto.core.private.triallimits.UpdateAlternateTrialLimitResponse', null, global);
goog.exportSymbol('proto.core.private.triallimits.UpdateStandardTrialLimitRequest', null, global);
goog.exportSymbol('proto.core.private.triallimits.UpdateStandardTrialLimitResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.UpdateStandardTrialLimitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.UpdateStandardTrialLimitRequest.displayName = 'proto.core.private.triallimits.UpdateStandardTrialLimitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.UpdateStandardTrialLimitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.UpdateStandardTrialLimitResponse.displayName = 'proto.core.private.triallimits.UpdateStandardTrialLimitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.CreateAlternateTrialLimitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.CreateAlternateTrialLimitRequest.displayName = 'proto.core.private.triallimits.CreateAlternateTrialLimitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.CreateAlternateTrialLimitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.CreateAlternateTrialLimitResponse.displayName = 'proto.core.private.triallimits.CreateAlternateTrialLimitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.UpdateAlternateTrialLimitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.displayName = 'proto.core.private.triallimits.UpdateAlternateTrialLimitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.UpdateAlternateTrialLimitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.displayName = 'proto.core.private.triallimits.UpdateAlternateTrialLimitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.DeleteAlternateTrialLimitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.displayName = 'proto.core.private.triallimits.DeleteAlternateTrialLimitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.DeleteAlternateTrialLimitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.displayName = 'proto.core.private.triallimits.DeleteAlternateTrialLimitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.GetTrialLimitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.GetTrialLimitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.GetTrialLimitsRequest.displayName = 'proto.core.private.triallimits.GetTrialLimitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.GetTrialLimitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.core.private.triallimits.GetTrialLimitsResponse.repeatedFields_, null);
};
goog.inherits(proto.core.private.triallimits.GetTrialLimitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.GetTrialLimitsResponse.displayName = 'proto.core.private.triallimits.GetTrialLimitsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.core.private.triallimits.TrialLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.core.private.triallimits.TrialLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.core.private.triallimits.TrialLimit.displayName = 'proto.core.private.triallimits.TrialLimit';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.UpdateStandardTrialLimitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.UpdateStandardTrialLimitRequest;
  return proto.core.private.triallimits.UpdateStandardTrialLimitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.UpdateStandardTrialLimitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitRequest} returns this
 */
proto.core.private.triallimits.UpdateStandardTrialLimitRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.UpdateStandardTrialLimitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.UpdateStandardTrialLimitResponse;
  return proto.core.private.triallimits.UpdateStandardTrialLimitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.UpdateStandardTrialLimitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.core.private.triallimits.UpdateStandardTrialLimitResponse} returns this
 */
proto.core.private.triallimits.UpdateStandardTrialLimitResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.CreateAlternateTrialLimitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.CreateAlternateTrialLimitRequest;
  return proto.core.private.triallimits.CreateAlternateTrialLimitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.CreateAlternateTrialLimitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitRequest} returns this
 */
proto.core.private.triallimits.CreateAlternateTrialLimitRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.CreateAlternateTrialLimitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialLimit: (f = msg.getTrialLimit()) && proto.core.private.triallimits.TrialLimit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.CreateAlternateTrialLimitResponse;
  return proto.core.private.triallimits.CreateAlternateTrialLimitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.core.private.triallimits.TrialLimit;
      reader.readMessage(value,proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader);
      msg.setTrialLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.CreateAlternateTrialLimitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialLimit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional TrialLimit trial_limit = 1;
 * @return {?proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.getTrialLimit = function() {
  return /** @type{?proto.core.private.triallimits.TrialLimit} */ (
    jspb.Message.getWrapperField(this, proto.core.private.triallimits.TrialLimit, 1));
};


/**
 * @param {?proto.core.private.triallimits.TrialLimit|undefined} value
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse} returns this
*/
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.setTrialLimit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.core.private.triallimits.CreateAlternateTrialLimitResponse} returns this
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.clearTrialLimit = function() {
  return this.setTrialLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.core.private.triallimits.CreateAlternateTrialLimitResponse.prototype.hasTrialLimit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialLimitId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.UpdateAlternateTrialLimitRequest;
  return proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialLimitId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialLimitId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 trial_limit_id = 1;
 * @return {number}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.getTrialLimitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest} returns this
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.setTrialLimitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitRequest} returns this
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialLimit: (f = msg.getTrialLimit()) && proto.core.private.triallimits.TrialLimit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.UpdateAlternateTrialLimitResponse;
  return proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.core.private.triallimits.TrialLimit;
      reader.readMessage(value,proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader);
      msg.setTrialLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialLimit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional TrialLimit trial_limit = 1;
 * @return {?proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.getTrialLimit = function() {
  return /** @type{?proto.core.private.triallimits.TrialLimit} */ (
    jspb.Message.getWrapperField(this, proto.core.private.triallimits.TrialLimit, 1));
};


/**
 * @param {?proto.core.private.triallimits.TrialLimit|undefined} value
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse} returns this
*/
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.setTrialLimit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.core.private.triallimits.UpdateAlternateTrialLimitResponse} returns this
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.clearTrialLimit = function() {
  return this.setTrialLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.core.private.triallimits.UpdateAlternateTrialLimitResponse.prototype.hasTrialLimit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialLimitId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.DeleteAlternateTrialLimitRequest;
  return proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialLimitId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialLimitId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 trial_limit_id = 1;
 * @return {number}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.prototype.getTrialLimitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitRequest} returns this
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitRequest.prototype.setTrialLimitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.DeleteAlternateTrialLimitResponse;
  return proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_success = 1;
 * @return {boolean}
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.core.private.triallimits.DeleteAlternateTrialLimitResponse} returns this
 */
proto.core.private.triallimits.DeleteAlternateTrialLimitResponse.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.GetTrialLimitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.GetTrialLimitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.GetTrialLimitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.GetTrialLimitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.GetTrialLimitsRequest}
 */
proto.core.private.triallimits.GetTrialLimitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.GetTrialLimitsRequest;
  return proto.core.private.triallimits.GetTrialLimitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.GetTrialLimitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.GetTrialLimitsRequest}
 */
proto.core.private.triallimits.GetTrialLimitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.GetTrialLimitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.GetTrialLimitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.GetTrialLimitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.GetTrialLimitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.core.private.triallimits.GetTrialLimitsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.GetTrialLimitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.GetTrialLimitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.GetTrialLimitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    standard: (f = msg.getStandard()) && proto.core.private.triallimits.TrialLimit.toObject(includeInstance, f),
    alternatesList: jspb.Message.toObjectList(msg.getAlternatesList(),
    proto.core.private.triallimits.TrialLimit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.GetTrialLimitsResponse;
  return proto.core.private.triallimits.GetTrialLimitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.GetTrialLimitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.core.private.triallimits.TrialLimit;
      reader.readMessage(value,proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader);
      msg.setStandard(value);
      break;
    case 2:
      var value = new proto.core.private.triallimits.TrialLimit;
      reader.readMessage(value,proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader);
      msg.addAlternates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.GetTrialLimitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.GetTrialLimitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.GetTrialLimitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandard();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter
    );
  }
  f = message.getAlternatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter
    );
  }
};


/**
 * optional TrialLimit standard = 1;
 * @return {?proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.getStandard = function() {
  return /** @type{?proto.core.private.triallimits.TrialLimit} */ (
    jspb.Message.getWrapperField(this, proto.core.private.triallimits.TrialLimit, 1));
};


/**
 * @param {?proto.core.private.triallimits.TrialLimit|undefined} value
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse} returns this
*/
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.setStandard = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse} returns this
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.clearStandard = function() {
  return this.setStandard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.hasStandard = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TrialLimit alternates = 2;
 * @return {!Array<!proto.core.private.triallimits.TrialLimit>}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.getAlternatesList = function() {
  return /** @type{!Array<!proto.core.private.triallimits.TrialLimit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.core.private.triallimits.TrialLimit, 2));
};


/**
 * @param {!Array<!proto.core.private.triallimits.TrialLimit>} value
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse} returns this
*/
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.setAlternatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.core.private.triallimits.TrialLimit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.addAlternates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.core.private.triallimits.TrialLimit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.core.private.triallimits.GetTrialLimitsResponse} returns this
 */
proto.core.private.triallimits.GetTrialLimitsResponse.prototype.clearAlternatesList = function() {
  return this.setAlternatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.core.private.triallimits.TrialLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.core.private.triallimits.TrialLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.core.private.triallimits.TrialLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.TrialLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
    trialLimitId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    key: jspb.Message.getFieldWithDefault(msg, 2, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.TrialLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.core.private.triallimits.TrialLimit;
  return proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.core.private.triallimits.TrialLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.core.private.triallimits.TrialLimit}
 */
proto.core.private.triallimits.TrialLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialLimitId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.core.private.triallimits.TrialLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.core.private.triallimits.TrialLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.core.private.triallimits.TrialLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrialLimitId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 trial_limit_id = 1;
 * @return {number}
 */
proto.core.private.triallimits.TrialLimit.prototype.getTrialLimitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.TrialLimit} returns this
 */
proto.core.private.triallimits.TrialLimit.prototype.setTrialLimitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.core.private.triallimits.TrialLimit.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.core.private.triallimits.TrialLimit} returns this
 */
proto.core.private.triallimits.TrialLimit.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.core.private.triallimits.TrialLimit.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.core.private.triallimits.TrialLimit} returns this
 */
proto.core.private.triallimits.TrialLimit.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.core.private.triallimits.TrialLimit.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.core.private.triallimits.TrialLimit} returns this
*/
proto.core.private.triallimits.TrialLimit.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.core.private.triallimits.TrialLimit} returns this
 */
proto.core.private.triallimits.TrialLimit.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.core.private.triallimits.TrialLimit.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.core.private.triallimits);
